import {Trans, useTranslation} from "react-i18next";
import React, {useEffect, useState} from "react";
import {useUrlParam} from "../hooks/useUrlParam";
import CustomModalHeader from "./CustomModalHeader";
import {Button, Modal, ModalBody} from "reactstrap";
import FlexRow from "./FlexRow";
import SolidButton from "./SolidButton";

export default function ClickSignToContinueModal({}) {
    const { t } = useTranslation()
    const [open, setOpen] = useState(false);
    const [fromFormParam, ] = useUrlParam('fromForm')

    useEffect(() => {
        if(fromFormParam === 'true') {
            setOpen(true)
        }
    }, [fromFormParam]);

    function toggle() {
        setOpen(prev => !prev);
    }

    function handleClose() {
        setOpen(false);
    }

    return (
        <Modal isOpen={open} toggle={handleClose}>
            <CustomModalHeader toggle={toggle}>
                <div>{t('tutorial modal click to sign title')}</div>
            </CustomModalHeader>
            <ModalBody>
                <div>
                    <p>
                        <Trans>
                            tutorial modal click to sign body
                        </Trans>
                    </p>
                </div>
                <FlexRow justifyContent="center">
                    <SolidButton color="primary" noMargin
                        onClick={toggle}
                    >{t('accept')}</SolidButton>{' '}
                </FlexRow>
            </ModalBody>
        </Modal>
    )


}
